import { type TaskRemoveInput, type TaskRemoveSuccess, toResponseError } from '@terros/common'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useTaskCache } from './cache'

export function useRemoveTask(): RemoveHookResponse<TaskRemoveInput> {
  const mutation = useTantalimMutation<TaskRemoveInput, TaskRemoveSuccess>({
    url: '/task/remove',
  })
  const cache = useTaskCache()

  async function remove(input: TaskRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
      cache.clearManagementList()
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
